import React, { useEffect, useState } from "react";
import { Drawer, Upload, Modal, notification, Select } from "antd";
import { UploadOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import styles from "./LmsBuyDrawer.module.css";
import qrCode from "../../../assets/qr_code.jpg";
import ButtonComponent from "../../../components/CssComponents/ButtonComponent/ButtonComponent";
import { db } from "../../../firebase-config";
import { arrayUnion, doc, getDoc, updateDoc } from "firebase/firestore";
import {
  savePayment,
  saveTransaction,
} from "../../../service/saveTransactions";
import { v4 as uuidv4 } from "uuid"; // Import uuid for unique file names
import { findUserWhoReferedMe } from "../../../service/findUsers/findUserWhoReferedMe";
import { updateUserEarnings } from "../../../service/updateEarnings/updateUserEarnings";
import { getCurrentTimestamp } from "../../../service/time/getCurrentTimestamp";
import { uploadFilesToFirebase } from "../../../service/uploadFilesToFirebase";

const LmsBuyDrawer = ({
  isVisible,
  onClose,
  buyItemType,
  buyItemPrice,
  buyItemCrossPrice,
  buyItemName,
  buyItemId,
  buyItemBanner,
  buyItemBatchIds,
  fetchPackages,
  fetchUserData,
  uid,
}) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [pendingUploads, setPendingUploads] = useState([]);

  const [batches, setBatches] = useState([]);

  const [selectedBatch, setSelectedBatch] = useState(null);

  useEffect(() => {
    const fetchBatches = async () => {
      try {
        // Step 2: Fetch batches one by one if available
        if (buyItemBatchIds?.length > 0) {
          const batchData = [];
          for (const batchId of buyItemBatchIds) {
            const batchDocRef = doc(db, "lms_batch", batchId);
            const batchDocSnap = await getDoc(batchDocRef);
            if (batchDocSnap.exists()) {
              batchData.push({ id: batchId, ...batchDocSnap.data() });
            }
          }
          setBatches(batchData);
        }
      } catch (err) {
        console.error("Failed to fetch data:", err);

        return;
      }
    };

    fetchBatches();
  }, [buyItemBatchIds]);

  const handleBatchChange = (value) => {
    const selectedBatch = batches.find((item) => item.id === value) || null;
    setSelectedBatch(selectedBatch);
  };

  const handlePreview = async (file) => {
    setPreviewImage(file.url);
    setPreviewVisible(true);
  };

  const handleCancelPreview = () => setPreviewVisible(false);

  // Handle file removal
  const handleRemove = (file) => {
    setPendingUploads((prev) => prev.filter((f) => f.uid !== file.uid));
    setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
  };

  // Handle file selection
  const handleChange = ({ fileList: newFileList }) => {
    // Validate and prevent duplicate filenames
    const uniqueFiles = newFileList.filter(
      (file, index, self) =>
        index === self.findIndex((f) => f.name === file.name)
    );

    if (uniqueFiles.length !== newFileList.length) {
      notification.warning({
        message: "Duplicate File",
        description: "A file with the same name already exists.",
        placement: "topRight",
        duration: 3,
      });
    }

    setPendingUploads(uniqueFiles);
    setFileList(
      uniqueFiles.map((file) => ({
        ...file,
        status: "done",
        url: file.url || URL.createObjectURL(file.originFileObj),
      }))
    );
  };

  //   const handleBuyClick = async () => {
  //     try {
  //       if (!uid) {
  //         notification.warning({
  //           message: "Kindly Login",
  //           description: "Kindly Login.",
  //           placement: "topRight",
  //           duration: 3,
  //         });
  //         return;
  //       }
  //       // Upload all pending files
  //       const uploadedUrls = await uploadFilesToFirebase(pendingUploads);

  //       // Validate Proof URLs
  //       if (!uploadedUrls.length) {
  //         notification.warning({
  //           message: "Upload Required",
  //           description:
  //             "Please upload at least one proof of payment before proceeding.",
  //           placement: "topRight",
  //           duration: 3,
  //         });
  //         return;
  //       }

  //       // Fetch the User Document
  //       const userRef = doc(db, "users", uid);
  //       const userSnapshot = await getDoc(userRef);

  //       if (!userSnapshot.exists()) {
  //         notification.warning({
  //           message: "User Data Not Found",
  //           description: "Contact Admin to resolve this issue.",
  //           placement: "topRight",
  //           duration: 3,
  //         });
  //         return;
  //       }

  //       const userData = userSnapshot.data();

  //       if (userData?.userTypes !== "team_leader") {
  //         notification.warning({
  //           message: "Access Denied",
  //           description: "Only students can purchase items.",
  //           placement: "topRight",
  //           duration: 3,
  //         });
  //         return;
  //       }

  //       // Check if User Already Has the items
  //       if (
  //         userData?.buyItemIdsArray?.some(
  //           (entry) => entry.buyItemId === buyItemId
  //         )
  //       ) {
  //         notification.warning({
  //           message: "Already Enrolled",
  //           description: "You have already enrolled.",
  //           placement: "topRight",
  //           duration: 3,
  //         });
  //         return;
  //       }

  //       const referringUserUid = await findUserWhoReferedMe(userData.referralId);

  //       console.log("Referring User UID:", referringUserUid);

  //       if (!referringUserUid) {
  //         notification.error({
  //           message: "No Referrer Found",
  //           description: "Contact Admin to resolve this issue.",
  //           placement: "topRight",
  //           duration: 3,
  //         });
  //         console.error("No referrer found for user:", uid);
  //         return;
  //       }

  //       const newItemEntry = {
  //         buyItemId: buyItemId || "ar_id",
  //         buyItemType: buyItemType || "ar_type",
  //         buyItemPrice: buyItemPrice || 0,
  //         proofUrls: uploadedUrls,
  //         status: "pending",
  //       };

  //       await updateDoc(userRef, {
  //         buyItemIdsArray: arrayUnion(newItemEntry),
  //       });

  //       // batch will available when type is package_lc
  //       // this is just to filter the joined batch
  //       // there is no price in batch things
  //       // this is just for categorization
  //       if (selectedBatch?.batchId) {
  //         if (
  //           userData?.buyItemIdsArray?.some(
  //             (entry) => entry.buyItemId === selectedBatch.batchId
  //           )
  //         ) {
  //           notification.warning({
  //             message: "Batch Already Enrolled",
  //             description: "You have already enrolled.",
  //             placement: "topRight",
  //             duration: 3,
  //           });
  //           return;
  //         }
  //         const newItemEntryBatch = {
  //           buyItemId: selectedBatch.batchId || "batch_id",
  //           buyItemType: selectedBatch.batchType || "batch",
  //           status: "approved",
  //         };
  //         await updateDoc(doc(db, "users", uid), {
  //           buyItemIdsArray: arrayUnion(newItemEntryBatch),
  //           updatedAt: getCurrentTimestamp(),
  //         });
  //       }

  //       if (referringUserUid) {
  //         await updateUserEarnings({
  //           referringUserUid: referringUserUid,
  //           buyItemPrice: buyItemPrice,
  //           buyItemId: buyItemId,
  //           studentUid: uid,
  //         });
  //       }

  //       await saveTransaction({
  //         type: "student_payment",
  //         direction: "credit",
  //         uid: uid,
  //         amount: buyItemPrice,
  //         itemId: buyItemId,
  //         reason: `Purchased ${buyItemName} (${buyItemType})`,
  //         proofUrls: uploadedUrls,
  //       });

  //       await savePayment({
  //         uid: uid,
  //         amount: buyItemPrice,
  //         itemId: buyItemId,
  //         reason: `Purchased ${buyItemName} (${buyItemType})`,
  //         proofUrls: uploadedUrls,
  //       });

  //       notification.success({
  //         message: "Congratulations!",
  //         description: "You have purchased the item successfully.",
  //         placement: "topRight",
  //         duration: 3,
  //       });

  //       onClose();
  //     } catch (error) {
  //       console.error("Error purchasing item:", error);
  //       notification.error({
  //         message: "Purchase Failed",
  //         description: "There was an error processing your item purchase.",
  //         placement: "topRight",
  //         duration: 3,
  //       });
  //     }
  //   };

  const handleBuyClick = async () => {
    try {
      if (!uid) {
        notification.warning({
          message: "Kindly Login",
          description: "Kindly Login.",
          placement: "topRight",
          duration: 3,
        });
        return;
      }

      // Upload all pending files
      const uploadedUrls = await uploadFilesToFirebase(pendingUploads);

      if (!uploadedUrls.length) {
        notification.warning({
          message: "Upload Required",
          description:
            "Please upload at least one proof of payment before proceeding.",
          placement: "topRight",
          duration: 3,
        });
        return;
      }

      // Fetch the user document
      const userRef = doc(db, "users", uid);
      const userSnapshot = await getDoc(userRef);

      if (!userSnapshot.exists()) {
        notification.warning({
          message: "User Data Not Found",
          description: "Contact Admin to resolve this issue.",
          placement: "topRight",
          duration: 3,
        });
        return;
      }

      const userData = userSnapshot.data();

      if (userData?.userTypes !== "team_leader") {
        notification.warning({
          message: "Access Denied",
          description: "Only students can purchase items.",
          placement: "topRight",
          duration: 3,
        });
        return;
      }

      // Check if user already purchased this main item
      if (
        userData?.buyItemIdsArray?.some(
          (entry) => entry.buyItemId === buyItemId
        )
      ) {
        notification.warning({
          message: "Already Enrolled",
          description: "You have already enrolled.",
          placement: "topRight",
          duration: 3,
        });
        return;
      }

      const referringUserUid = await findUserWhoReferedMe(userData.referralId);

      if (!referringUserUid) {
        notification.error({
          message: "No Referrer Found",
          description: "Contact Admin to resolve this issue.",
          placement: "topRight",
          duration: 3,
        });
        console.error("No referrer found for user:", uid);
        return;
      }

      // Add main item to user
      const newItemEntry = {
        buyItemId: buyItemId || "ar_id",
        buyItemType: buyItemType || "ar_type",
        buyItemPrice: buyItemPrice || 0,
        proofUrls: uploadedUrls,
        createdAt: new Date(),
        status: "pending",
      };

      await updateDoc(userRef, {
        buyItemIdsArray: arrayUnion(newItemEntry),
      });

      // Refresh userData after adding main item
      const updatedSnapshot = await getDoc(userRef);
      const updatedUserData = updatedSnapshot.data();

      // Handle batch enrollment for package_lc
      if (selectedBatch?.id) {
        const alreadyBatchEnrolled = updatedUserData?.buyItemIdsArray?.some(
          (entry) => entry.buyItemId === selectedBatch.id
        );

        if (!alreadyBatchEnrolled) {
          const newItemEntryBatch = {
            buyItemId: selectedBatch.id,
            buyItemType: selectedBatch.batchType || "batch",
            status: "approved",
          };

          await updateDoc(userRef, {
            buyItemIdsArray: arrayUnion(newItemEntryBatch),
            updatedAt: getCurrentTimestamp(),
          });
        }
      }

      // Update referring user earnings
      await updateUserEarnings({
        referringUserUid,
        buyItemPrice,
        buyItemId,
        studentUid: uid,
      });

      // Save transaction and payment
      await saveTransaction({
        type: "student_payment",
        direction: "credit",
        uid,
        amount: buyItemPrice,
        itemId: buyItemId,
        reason: `Purchased ${buyItemName} (${buyItemType})`,
        proofUrls: uploadedUrls,
      });

      await savePayment({
        uid,
        amount: buyItemPrice,
        itemId: buyItemId,
        reason: `Purchased ${buyItemName} (${buyItemType})`,
        proofUrls: uploadedUrls,
      });
      await fetchPackages();
      await fetchUserData();
      notification.success({
        message: "Congratulations!",
        description: "You have purchased the item successfully.",
        placement: "topRight",
        duration: 3,
      });
      onClose();
    } catch (error) {
      console.error("Error purchasing item:", error);
      notification.error({
        message: "Purchase Failed",
        description: "There was an error processing your item purchase.",
        placement: "topRight",
        duration: 3,
      });
    }
  };

  return (
    <Drawer
      title={"Item Details"}
      placement="right"
      onClose={onClose}
      open={isVisible}
      width={350}
      closeIcon={<CloseCircleOutlined style={{ color: "#b17e32" }} />}
    >
      <div className={styles.container}>
        {/* Header Section */}
        <div className={styles.header}>
          <img
            src={buyItemBanner || "https://via.placeholder.com/150"}
            alt={buyItemName}
            className={styles.courseImage}
          />
          <div className={styles.courseInfo}>
            <div className={styles.courseTitle}>{buyItemName}</div>
            <div className={styles.coursePrice}>Buy Price : {buyItemPrice}</div>
            <div className={styles.coursePrice}>
              Original Price : {buyItemCrossPrice}
            </div>
          </div>
        </div>

        {buyItemType === "package_lc" && buyItemBatchIds?.length > 0 && (
          <div className={styles.labelInputWrapper}>
            <div className={styles.labelText}>Select Batches</div>
            <Select
              required
              name="selectedBatch"
              allowClear
              showSearch
              optionFilterProp="label"
              placeholder="Select batches"
              value={selectedBatch?.batchId || null}
              onChange={handleBatchChange}
              options={
                batches.map((item) => ({
                  label: item.batchName,
                  value: item.batchId,
                })) || []
              }
            />
          </div>
        )}

        {/* QR Code Section */}
        <div className={styles.qrCodeSection}>
          <img src={qrCode} alt="QR Code" className={styles.qrCodeImage} />
          <p className={styles.qrCodeText}>Scan QR Code to Pay!</p>
        </div>

        {/* Upload Section */}
        <div className={styles.uploadSection}>
          <Upload
            fileList={fileList}
            onChange={handleChange}
            onPreview={handlePreview}
            onRemove={handleRemove}
            listType="picture-card"
            accept="image/*"
            beforeUpload={() => false} // Prevent auto-upload
          >
            {fileList.length < 5 && (
              <div>
                <UploadOutlined />
                <div style={{ marginTop: 8 }}>Upload Screenshot</div>
              </div>
            )}
          </Upload>

          <Modal
            open={previewVisible}
            footer={null}
            onCancel={handleCancelPreview}
          >
            <img alt="Preview" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </div>

        <div className={styles.actions}>
          <ButtonComponent
            className={styles.btn}
            onClick={handleBuyClick}
            buttonText={"Buy"}
          />
          <ButtonComponent
            className={styles.btn}
            buttonText={"Cancel"}
            onClick={onClose}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default LmsBuyDrawer;
